













































import { Mixins, Component } from "vue-property-decorator";
import { NumberInput } from "../../../../../../../base/components/system";
import { DialogMixin } from "../../../../../../../base/components/system/mixins";
import { ObjectUtility } from "../../../../../../../base/utilities";
import { ITableSize } from "../../../../../../../documaker/domain/format/objects";

@Component({
  components: {
    NumberInput,
  },
})
export default class TableSizeEditDialog extends Mixins(DialogMixin) {
  tableSize: ITableSize = { row: 1, column: 1 };
  confirmed: boolean = false;

  get row(): number {
    return this.tableSize.row;
  }

  set row(value: number) {
    this.tableSize.row = value;
  }

  get column(): number {
    return this.tableSize.column;
  }

  set column(value: number) {
    this.tableSize.column = value;
  }

  async show(tableSize: ITableSize): Promise<ITableSize> {
    return this.showModal(async () => {
      this.tableSize = ObjectUtility.copyDeeply(tableSize);
      this.confirmed = false;
      await this.waitHidden();
      return this.confirmed ? this.tableSize : null;
    });
  }

  correct(value: number): number {
    return Math.floor(value);
  }

  validate(value: number): boolean {
    return 0 < value;
  }

  confirm(): void {
    this.confirmed = true;
    this.isVisible = false;
  }

  cancel(): void {
    this.isVisible = false;
  }
}
